var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { "data-grm-comp": "UrlShareTable" } }, [
    _c("div", { staticClass: "h-full flex-col hidden lg:flex" }, [
      _c("table", { staticClass: "url-share-table" }, [
        _vm._m(0),
        _c("thead", { staticClass: "h-8 bg-gray-200" }, [
          _c("tr", [
            _c("th", [_vm._v(_vm._s(_vm.$t("common.number")))]),
            _c("th", [_vm._v(_vm._s(_vm.$t("setting.name.title")))]),
            _c("th", [_vm._v(_vm._s(_vm.$t("link.path")))]),
            _c("th", [_vm._v(_vm._s(_vm.$t("link.regDate")))]),
            _c("th"),
          ]),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "max-h-full overflow-y-auto scrollbar-hidden" },
        [
          _c("table", { staticClass: "url-share-table" }, [
            _vm._m(1),
            _c(
              "tbody",
              [
                [
                  _vm._l(_vm.urlShareDataList, function (urlShare, i) {
                    return _c(
                      "tr",
                      {
                        key: urlShare.urlIdx,
                        staticClass:
                          "cursor-pointer transition hover:bg-gray-100",
                      },
                      [
                        _c("td", [
                          _vm._v(_vm._s(_vm.urlShareNum(urlShare, i))),
                        ]),
                        _c(
                          "td",
                          [
                            _vm.isEdit(urlShare)
                              ? [
                                  _c("GrmTextField", {
                                    ref: "urlTitle",
                                    refInFor: true,
                                    attrs: { size: "xs", textalign: "center" },
                                    on: {
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "esc",
                                              27,
                                              $event.key,
                                              ["Esc", "Escape"]
                                            )
                                          )
                                            return null
                                          return _vm.onCancelURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.onCreateURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                      ],
                                    },
                                    model: {
                                      value: urlShare.urlTitle,
                                      callback: function ($$v) {
                                        _vm.$set(urlShare, "urlTitle", $$v)
                                      },
                                      expression: "urlShare.urlTitle",
                                    },
                                  }),
                                ]
                              : [_vm._v(_vm._s(urlShare.urlTitle))],
                          ],
                          2
                        ),
                        _c(
                          "td",
                          [
                            _vm.isEdit(urlShare)
                              ? [
                                  _c("GrmTextField", {
                                    ref: "urlPath",
                                    refInFor: true,
                                    attrs: { size: "xs", textalign: "center" },
                                    on: {
                                      keydown: [
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "esc",
                                              27,
                                              $event.key,
                                              ["Esc", "Escape"]
                                            )
                                          )
                                            return null
                                          return _vm.onCancelURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                        function ($event) {
                                          if (
                                            !$event.type.indexOf("key") &&
                                            _vm._k(
                                              $event.keyCode,
                                              "enter",
                                              13,
                                              $event.key,
                                              "Enter"
                                            )
                                          )
                                            return null
                                          return _vm.onCreateURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                      ],
                                    },
                                    model: {
                                      value: urlShare.urlPath,
                                      callback: function ($$v) {
                                        _vm.$set(urlShare, "urlPath", $$v)
                                      },
                                      expression: "urlShare.urlPath",
                                    },
                                  }),
                                ]
                              : [
                                  _c(
                                    "div",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.onStartURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(urlShare.urlPath))]
                                  ),
                                ],
                          ],
                          2
                        ),
                        _c("td", [_vm._v(_vm._s(urlShare.uptDate ?? "-"))]),
                        _c("td", [
                          _vm.isEdit(urlShare)
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "w-full flex justify-center gap-x-1",
                                },
                                [
                                  _c(
                                    "GrmBtn",
                                    {
                                      attrs: { size: "xs" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCreateURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.register")))]
                                  ),
                                  _c(
                                    "GrmBtn",
                                    {
                                      attrs: { size: "xs", color: "red" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onCancelURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.isEdit(urlShare) &&
                          (_vm.me.userId === urlShare.regUserId ||
                            _vm.hasEmceeRole())
                            ? _c(
                                "div",
                                { staticClass: "w-full flex gap-x-1" },
                                [
                                  _c(
                                    "GrmBtn",
                                    {
                                      staticClass: "flex-1",
                                      attrs: { size: "sm" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onUpdateURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.edit")))]
                                  ),
                                  _c(
                                    "GrmBtn",
                                    {
                                      staticClass: "flex-1",
                                      attrs: { size: "sm", color: "red" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.onRemoveURLShare(
                                            $event,
                                            urlShare
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("common.delete")))]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]),
                      ]
                    )
                  }),
                  !_vm.urlShareDataList.length
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "text-center",
                            attrs: { colspan: "5" },
                          },
                          [_vm._v(_vm._s(_vm.$t("link.share.notExist")))]
                        ),
                      ])
                    : _vm._e(),
                ],
              ],
              2
            ),
          ]),
        ]
      ),
    ]),
    _c(
      "div",
      { staticClass: "flex flex-col gap-2 lg:hidden" },
      [
        _vm._l(_vm.urlShareDataList, function (urlShare, i) {
          return _c(
            "div",
            { key: urlShare.urlIdx, staticClass: "p-2 rounded bg-gray-100" },
            [
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("common.number"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(
                    _vm._s(
                      _vm.isEdit(urlShare)
                        ? urlShare.urlIdx
                          ? i + 1
                          : "-"
                        : i + 1
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("setting.name.title"))),
                ]),
                _c(
                  "div",
                  { staticClass: "min-w-0 flex-1 py-1 px-3 text-sm lg:py-2" },
                  [
                    _vm.isEdit(urlShare)
                      ? [
                          _c("GrmTextField", {
                            ref: "urlTitle",
                            refInFor: true,
                            attrs: { size: "xs" },
                            on: {
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "esc",
                                      27,
                                      $event.key,
                                      ["Esc", "Escape"]
                                    )
                                  )
                                    return null
                                  return _vm.onCancelURLShare($event, urlShare)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.onCreateURLShare($event, urlShare)
                                },
                              ],
                            },
                            model: {
                              value: urlShare.urlTitle,
                              callback: function ($$v) {
                                _vm.$set(urlShare, "urlTitle", $$v)
                              },
                              expression: "urlShare.urlTitle",
                            },
                          }),
                        ]
                      : [_vm._v(_vm._s(urlShare.urlTitle))],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("link.path"))),
                ]),
                _c(
                  "div",
                  { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" },
                  [
                    _vm.isEdit(urlShare)
                      ? [
                          _c("GrmTextField", {
                            ref: "urlpath",
                            refInFor: true,
                            attrs: { size: "xs" },
                            on: {
                              keydown: [
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "esc",
                                      27,
                                      $event.key,
                                      ["Esc", "Escape"]
                                    )
                                  )
                                    return null
                                  return _vm.onCancelURLShare($event, urlShare)
                                },
                                function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.onCreateURLShare($event, urlShare)
                                },
                              ],
                            },
                            model: {
                              value: urlShare.urlPath,
                              callback: function ($$v) {
                                _vm.$set(urlShare, "urlPath", $$v)
                              },
                              expression: "urlShare.urlPath",
                            },
                          }),
                        ]
                      : [
                          _c(
                            "div",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.onStartURLShare($event, urlShare)
                                },
                              },
                            },
                            [_vm._v(_vm._s(urlShare.urlPath ?? "-"))]
                          ),
                        ],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "flex" }, [
                _c("div", { staticClass: "w-28 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(_vm.$t("link.regDate"))),
                ]),
                _c("div", { staticClass: "min-w-0 flex-1 py-2 px-3 text-sm" }, [
                  _vm._v(_vm._s(urlShare.uptDate ?? "-")),
                ]),
              ]),
              _c("div", { staticClass: "py-2 px-3 flex justify-center" }, [
                _vm.isEdit(urlShare)
                  ? _c(
                      "div",
                      { staticClass: "w-full flex justify-center gap-x-1" },
                      [
                        _c(
                          "GrmBtn",
                          {
                            staticClass: "flex-1",
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onCreateURLShare($event, urlShare)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.register")))]
                        ),
                        _c(
                          "GrmBtn",
                          {
                            staticClass: "flex-1",
                            attrs: { size: "sm", color: "red" },
                            on: {
                              click: function ($event) {
                                return _vm.onCancelURLShare($event, urlShare)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                !_vm.isEdit(urlShare) &&
                (_vm.me.userId === urlShare.regUserId || _vm.hasEmceeRole())
                  ? _c(
                      "div",
                      { staticClass: "w-full flex gap-x-1" },
                      [
                        _c(
                          "GrmBtn",
                          {
                            staticClass: "flex-1",
                            attrs: { size: "sm" },
                            on: {
                              click: function ($event) {
                                return _vm.onUpdateURLShare($event, urlShare)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.edit")))]
                        ),
                        _c(
                          "GrmBtn",
                          {
                            staticClass: "flex-1",
                            attrs: { size: "sm", color: "red" },
                            on: {
                              click: function ($event) {
                                return _vm.onRemoveURLShare($event, urlShare)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.$t("common.delete")))]
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ]
          )
        }),
        !_vm.urlShareDataList.length
          ? _c("div", [
              _c(
                "p",
                { staticClass: "text-center p-2 rounded bg-gray-100 text-sm" },
                [_vm._v(_vm._s(_vm.$t("link.share.notExist")))]
              ),
            ])
          : _vm._e(),
      ],
      2
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticClass: "col-a" }),
      _c("col", { staticClass: "col-b" }),
      _c("col", { staticClass: "col-c" }),
      _c("col", { staticClass: "col-d" }),
      _c("col", { staticClass: "col-e" }),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("colgroup", [
      _c("col", { staticClass: "col-a" }),
      _c("col", { staticClass: "col-b" }),
      _c("col", { staticClass: "col-c" }),
      _c("col", { staticClass: "col-d" }),
      _c("col", { staticClass: "col-e" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }